import { render } from "./ModalNotesHistory.vue?vue&type=template&id=6bac1348&scoped=true"
import script from "./ModalNotesHistory.vue?vue&type=script&lang=js"
export * from "./ModalNotesHistory.vue?vue&type=script&lang=js"

import "./ModalNotesHistory.vue?vue&type=style&index=0&id=6bac1348&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bac1348"]])

export default __exports__